<template>
  <div
    class="sticky top-0 z-10 flex-shrink-0 flex h-16 border-b border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700"
  >
    <button
      type="button"
      class="px-4 dark:border-gray-600 text-gray-500 focus:outline-none lg:hidden"
      @click="$emit('toggle')"
    >
      <span class="sr-only">Abrir menu</span>
      <bars3-icon class="h-6 w-6" />
    </button>
    <div class="flex-1 px-4 flex justify-between">
      <div class="flex-1 flex">
        <div
          v-if="!isBasic"
          class="w-full flex lg:ml-0"
        >
          <label
            for="search-field"
            class="sr-only"
          >
            Pesquisar
          </label>
          <div class="relative w-full text-gray-400 focus-within:text-gray-600 dark:focus-within:text-gray-200">
            <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
              <magnifying-glass-icon class="h-6 w-6" />
            </div>
            <input
              id="search-field"
              v-model="query"
              type="search"
              placeholder="Pesquisar"
              class="block w-full h-full pl-8 pr-3 py-2 border-transparent bg-transparent text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:placeholder-gray-400 dark:focus:placeholder-gray-500 focus:ring-0 focus:border-transparent text-sm"
              @focus="search = true"
              @blur="hide"
              @input="onSearch"
            >
          </div>
        </div>
      </div>
      <div
        v-show="search"
        class="relative z-10"
        role="dialog"
        aria-modal="true"
      >
        <div class="fixed w-full z-10 top-16 lg:left-64 right-0">
          <div
            class="overflow-hidden bg-white dark:bg-gray-700 border-b border-gray-300 dark:border-gray-600 transition-all"
          >
            <p
              v-if="query.length <= 0"
              class="p-4 text-sm text-gray-500 dark:text-gray-300"
            >
              Pesquise por Nome, CPF ou ID
            </p>
            <ul
              v-else-if="customers.length > 0"
              id="options"
              class="max-h-72 scroll-py-2 overflow-y-auto py-2 text-sm text-gray-800 dark:text-gray-300"
              role="listbox"
            >
              <li
                v-for="customer in customers"
                :key="customer.id"
                class="cursor-default select-none"
              >
                <router-link
                  v-if="!isBasic"
                  :to="{ name: 'blitz.customers.show', params: { id: customer.id } }"
                  class="block px-4 py-2"
                >
                  {{ customer.name }}
                </router-link>
                <span
                  v-else
                  class="block px-4 py-2"
                >{{ customer.name }}</span>
              </li>
            </ul>
            <p
              v-else
              class="p-4 text-sm text-gray-500 dark:text-gray-300"
            >
              Nenhum resultado encontrado.
            </p>
          </div>
        </div>
      </div>
      <div class="flex items-center">
        <!-- <b-dropdown
          label="user-notifications"
          class="ml-3 relative"
        >
          <template #toggle>
            <button
              id="user-notifications"
              class="p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none"
              aria-haspopup="true"
            >
              <span class="sr-only">Ver notificações</span>
              <bell-icon class="h-6 w-6" />
            </button>
          </template>
          <ul>
            <li class="text-center px-4 py-2 font-medium text-sm text-gray-700 hover:bg-gray-50 dark:text-white dark:hover:bg-gray-500">
              Nenhuma notificação recente
            </li>
          </ul>
        </b-dropdown> -->
        <b-dropdown
          label="user-menu"
          class="ml-3 relative"
        >
          <template #toggle>
            <button
              id="user-menu"
              class="max-w-xs flex items-center text-sm focus:outline-none"
              aria-haspopup="true"
            >
              <span class="font-medium text-gray-900 dark:text-gray-100 mr-3">
                {{ firstName }}
              </span>
              <img
                class="h-8 w-8 p-1 bg-gray-300 rounded-full"
                src="/avatar.png"
              >
            </button>
          </template>
          <button
            class="block w-full px-4 py-2 font-medium text-sm text-left text-gray-700 hover:bg-gray-50 dark:text-white dark:hover:bg-gray-500"
            @click="profile"
          >
            Meu Perfil
          </button>
          <button
            class="block w-full px-4 py-2 font-medium text-sm text-left text-gray-700 hover:bg-gray-50 dark:text-white dark:hover:bg-gray-500"
            @click="logout"
          >
            Sair
          </button>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { useBlitzStore } from '../stores/BlitzStore'
import BDropdown from '@/components/BDropdown.vue'
import { Bars3Icon, MagnifyingGlassIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Bars3Icon,
    BDropdown,
    MagnifyingGlassIcon
  },
  emits: ['toggle'],
  data () {
    return {
      search: false,
      query: '',
      timer: null,
      results: 0,
      customers: []
    }
  },
  computed: {
    currentUser () {
      const store = useBlitzStore()
      return store.user
    },
    firstName () {
      return this.capitalize(this.currentUser?.name.split(' ')[0])
    },
    id () {
      return this.currentUser?.id
    },
  },
  watch: {
    '$route' (to, from) {
      this.query = ''
    }
  },
  methods: {
    fetchData () {
      if (this.query) {
        this.$http.get('/api/blitz/search', {
          headers: { ...this.authHeader() },
          params: { query: this.query }
        })
          .then(response => {
            this.results = response.data?.results ?? 0
            this.customers = response.data?.customers ?? []
          })
          .catch(_error => {
            //
          })
      }
    },
    hide () {
      const ref = this
      setTimeout(function () {
        ref.search = false
      }, 150)
    },
    logout () {
      this.$router.push('/logout')
    },
    onSearch () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.fetchData()
      }, 500)
    },
    profile () {
      this.$router.push({ name: 'blitz.users.show', params: { id: this.id } })
    }
  }
}
</script>
